import { capitalize } from "utils/capitalize";
import { leaveTypes, periodMap } from "pages/StaffApplication/constants";
import { absTimeDifference } from "utils/timeDifference";
import { getFileExtension } from "utils/getFileExtension";
import { ProtectedLink, ProtectedImg } from "components";

export const ModalBody = ({ state, type, expandImage }) => {
	return (
		<>
			<div className="row text-white px-4 text-left">
				<div className="col-12 col-sm-6 mb-4">
					<div className="font-weight-bold text-primary">{capitalize(type)} Date</div>
					<div>{new Date(state?.data?.date).toString().slice(0, 15)}</div>
				</div>
				<div className="col-12 col-sm-6 mb-4">
					<div className="font-weight-bold text-primary">Employee Name</div>
					<div>{state?.data?.staff?.fullName}</div>
				</div>
				{state?.data?.type && (
					<div className="col-12 col-sm-6 mb-4">
						<div className="font-weight-bold text-primary">Type</div>
						<div>{leaveTypes.find((leave) => leave.value === state?.data?.type)?.label}</div>
					</div>
				)}
				{state?.data?.period && (
					<div className="col-12 col-sm-6 mb-4">
						<div className="font-weight-bold text-primary">Period</div>
						<div>{periodMap[state?.data?.period]}</div>
					</div>
				)}
				{state?.data?.approvedReason && (
					<div className="col-12 col-sm-6 mb-4">
						<div className="font-weight-bold text-primary">Approval/Disapproval Reason</div>
						<div className="text-info">{state?.data?.approvedReason}</div>
					</div>
				)}
				{state?.data?.startTime && (
					<div className="col-12 col-sm-6 mb-4">
						<div className="font-weight-bold text-primary">Start</div>
						<div>{state?.data?.startTime}</div>
					</div>
				)}
				{state?.data?.endTime && (
					<div className="col-12 col-sm-6 mb-4">
						<div className="font-weight-bold text-primary">End</div>
						<div>{state?.data?.endTime}</div>
					</div>
				)}
				{state?.data?.startTime && state?.data?.endTime && (
					<div className="col-12 col-sm-6 mb-4">
						<div className="font-weight-bold text-primary">Duration</div>
						<div>{(absTimeDifference(state?.data?.startTime, state?.data?.endTime) / 60).toFixed(2)} hours</div>
					</div>
				)}
				{state?.data?.reason && (
					<div className="col-12 mb-4">
						<div className="font-weight-bold text-primary">Reason</div>
						<div>{state?.data?.reason}</div>
					</div>
				)}
				{state?.data?.proof && (
					<div className="col-12 text-left">
						<div className="font-weight-bold text-primary">Proof</div>
						{getFileExtension(state?.data?.proof) === "pdf" ? (
							<ProtectedLink href={state?.data?.proof} target="_blank" className="badge badge-secondary" label="Click To View Proof" />
						) : (
							<ProtectedImg src={state?.data?.proof} alt="" className="img-fluid" onClick={expandImage} />
						)}
					</div>
				)}
			</div>
			<div className="mx-3 py-3 text-right">
				<small className="text-muted">Submitted at: {new Date(state?.data?.submittedAt).toLocaleString()}</small>
			</div>
		</>
	);
};
